export type ProdutosReviewSearch = {
  reviewRequestId?: string;
  reviewMode?: "create" | "map" | "reject";
};

export function readProdutosReviewSearch(
  search: Record<string, unknown>,
): ProdutosReviewSearch {
  const reviewRequestId =
    typeof search.reviewRequestId === "string"
      ? search.reviewRequestId
      : undefined;

  const reviewMode =
    search.reviewMode === "create" ||
    search.reviewMode === "map" ||
    search.reviewMode === "reject"
      ? search.reviewMode
      : undefined;

  return { reviewRequestId, reviewMode };
}
